<a data-skip-link href="#main-content">{{ skipLinkLabel }}</a>
<header ui
  #appHeader
  [ariaLabel]="headerAriaLabel"
  [userName]="userName()"
  [userEmail]="userEmail()"
  [userRole]="userRoleLabel()"
  [userInitials]="userInitials()"
  [avatarSrc]="avatarSrc()"
  [notificationUnread]="notificationUnread()"
  [role]="activeRole()"
  [roleOptions]="roleOptions()"
  [searchPlaceholder]="searchPlaceholder"
  [logoMode]="brandMode()"
  [brandCompact]="brandCompact()"
  [sidebarOpen]="sidebarOpen"
  (menuToggle)="toggleSidebar()"
  (roleChange)="changeRole($event)"
  (signOut)="signOut()"
  [searchSuggestions]="searchSuggestions()"
  (suggestionSelected)="onSuggestionSelected($event)"
  (searchSubmitted)="onSearchSubmitted($event)">
  <lib-notification-center notifications [embedded]="true" (itemOpened)="appHeader.closeAccount()"></lib-notification-center>
</header>
<div data-sidebar-backdrop aria-hidden="true" [attr.data-open]="sidebarOpen" (click)="sidebarOpen = false"></div>
<aside ui
  [ariaLabel]="asideAriaLabel"
  [navItems]="navItems()"
  [collapsed]="collapsed"
  [overlayOpen]="sidebarOpen"
  (overlayOpenChange)="sidebarOpen = $event"
  (collapseToggle)="toggleCollapsed()"
  (searchSubmitted)="onSearchSubmitted($event)">
</aside>
<main ui id="main-content" tabindex="-1" [ariaLabel]="mainAriaLabel">
  <router-outlet></router-outlet>
</main>
<contact-overlays></contact-overlays>
